var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardcard3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FEF1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 27.5C16.6673 24.1667 13.334 21.25 13.334 18.3334C13.334 16.5652 14.0364 14.8696 15.2866 13.6193C16.5368 12.3691 18.2325 11.6667 20.0007 11.6667C21.7688 11.6667 23.4645 12.3691 24.7147 13.6193C25.9649 14.8696 26.6673 16.5652 26.6673 18.3334C26.6673 21.25 23.334 24.1667 20.0007 27.5Z",
    stroke: "url(#paint0_linear_3_5125)",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.8333C21.3807 20.8333 22.5 19.714 22.5 18.3333C22.5 16.9526 21.3807 15.8333 20 15.8333C18.6193 15.8333 17.5 16.9526 17.5 18.3333C17.5 19.714 18.6193 20.8333 20 20.8333Z",
    stroke: "url(#paint1_linear_3_5125)",
    strokeWidth: 1.66667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_5125",
    x1: 20.0007,
    y1: 11.6667,
    x2: 20.0007,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_5125",
    x1: 20,
    y1: 15.8333,
    x2: 20,
    y2: 20.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardcard3);
export default __webpack_public_path__ + "static/media/dashboard card 3.5e681a6a2d89c92848dd8a41512124d6.svg";
export { ForwardRef as ReactComponent };